import React, { Fragment, useEffect} from 'react'
import { PageTitle } from '../../UI'
import { Redirect } from 'react-router-dom'
import { Modal } from '../../../components/Modal'
import { CreatePosition, SearchPosition, ViewPosition } from './index'
import { SnackBar } from '../../../components/SnackBar/Snackbar'
import { ConfirmAction } from '../../../components/ConfirmAction'
import { useConfirmsAction } from '../../../hooks/useConfirmAction'
import { usePosition } from '../context'
import positionBusiness from '../actions/positionBusiness'
import { Box, Button, Container, Paper } from '@mui/material'
import positionActions from '../actions/positionActions'
import { PositionTable } from './PositionTable/PositionTable'
import { useStyles } from './styles'
import { Modal as EOSModal } from '../../_EOS/Modal'
import { DialogInfo } from '../../PositionMassive/DialogInfo'
import { ControlsUpload } from '../../PositionMassive/ControlsUpload'
import { ControlsButtonsMasiv } from '../../PositionMassive/ControlsButtonsMasiv'

const PositionWrapper = () => {
  const { isLoadingConfirm } = useConfirmsAction()
  const { state, dispatch } = usePosition()
  
  const {
    redirect,
    openView,
    openDelete,
    openRedireccion,
    openSnackbar,
    messageColor,
    messageStatus,
    editableItem,
    rowsPerPage,
    page,
    sorters,
    firstEffect,
    editModePositionMasive
  } = state
  const {
    handleClose,
    handleCloseDelete,
    handleCloseView,
    handleCloseRedireccion,
    handleSnackbar,
    handleRedireccionZona,
    handleSubmitDelete,
    fetchFilteredData,
    handleOpen,
    handleOpenPositionMassive,
    handleClosePositionMassive,
    fetchExportData
  } = positionBusiness()

  const { setFirstEffect, setZoneDDL } = positionActions()

  const classes = useStyles()

  useEffect(() => {
    if (!firstEffect) {
      fetchFilteredData()
    } else {
      dispatch(setFirstEffect(false))
    }
  }, [sorters, page, rowsPerPage])

  if (redirect) {
    return <Redirect to='/wms/position' />
  }

  return (
    <Fragment>
      <PageTitle title='GESTIONAR POSICIÓN' />
      <Box display='flex' flexDirection='column'>
        <SearchPosition />

        <ControlsButtonsMasiv
          handleOpenPositionMassive={handleOpenPositionMassive}
          fetchExportData={fetchExportData}
        />

        <Box marginTop={2} />

        <Container maxWidth='xl'>
          <Paper elevation={3}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '20px'
              }}
            >
              <Box className={classes.buttonBar}>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    handleOpen()
                    dispatch(setZoneDDL([]))
                  }}
                >
                  Crear Posición
                </Button>
              </Box>
              <PositionTable/>
            </Box>
          </Paper>
        </Container>
      </Box>

      <Modal
        funcClose={handleClose}
        isOpen={state.open}
        size='XS'
        title={editableItem ? 'Editar Posición' : 'Crear Posición'}
      >
        <CreatePosition/>
      </Modal>

      <Modal
        funcClose={handleCloseView}
        isOpen={openView}
        backdropClick={false}
        size='XS'
      >
        <ViewPosition />
      </Modal>

      <EOSModal onClose={handleCloseDelete} open={openDelete} maxWidth='sm'>
        <ConfirmAction
          handleCloseModal={handleCloseDelete}
          handleSubmitAction={handleSubmitDelete}
          confirmTitle='¿Desea eliminar el registro?'
          confirmText='Confirmar'
          negateText='Volver atras'
          isLoading={isLoadingConfirm}
        />
      </EOSModal>

      <Modal
        funcClose={handleCloseRedireccion}
        isOpen={openRedireccion}
        size='XS'
      >
        <ConfirmAction
          handleCloseModal={handleCloseRedireccion}
          handleSubmitAction={handleRedireccionZona}
          confirmTitle='¿Desea ir al mantenedor de Sub-Zonas?'
          confirmText='Confirmar'
          negateText='Volver atras'
        />
      </Modal>

      <Modal
        funcClose={handleClosePositionMassive}
        isOpen={state.openPositionMassive}
        size='SM'
        title={
          editModePositionMasive
            ? 'Editar Posiciones Masivas'
            : 'Crear Posiciones Masivas'
        }
      >
        <DialogInfo editMode={editModePositionMasive} />
        <ControlsUpload editMode={editModePositionMasive}/>
      </Modal>

      <SnackBar
        open={openSnackbar}
        setOpen={handleSnackbar}
        message={messageStatus}
        status={messageColor}
      />
    </Fragment>
  )
}

export default PositionWrapper
